import React from 'react'
import ProgrammeSection from './Section/ProgrammeSection'

const Programme = () => {
  return (
    <div>
        <ProgrammeSection/>
    </div>
  )
}

export default Programme
